import React from 'react';
import Header from './components/Header';
import HomePage from './components/HomePage';
import Footer from './components/Footer';
import RegistrationForm from './components/RegistrationForm';
import AboutUs from './components/AboutUs';
import WhoWeServe from './components/WhoWeServe';
import FAQs from './components/FAQs';
import TermsAndCondition from './components/TermsAndCondition';
import TutorsAndSchools from './components/WhatWeOffer';
import SubjectsAndDiscipline from './components/SubjectsAndDiscipline';
import ScrollToTop from './components/ScrollToTop';
import PrivacyPolicy from './components/PrivacyPolicy';

import { Routes, Route } from 'react-router-dom';
import backgroundImage from './assets/images/background_image.jpg';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    // Outer div: white background for empty side areas, full height
    <div className="min-h-screen w-full bg-white">
      {/* Centered container – 90% width, flex column */}
      <div className="w-[90%] mx-auto min-h-screen flex flex-col">
        
        {/* Header – no border, no background image */}
        <Header />

        {/* Middle section: background image + border */}
        <div className="relative flex-grow border border-gray-300 rounded-xl overflow-hidden mb-6">
          {/* Background image – fills this entire div */}
          <img
            src={backgroundImage}
            alt="Background"
            className="absolute inset-0 w-full h-full object-cover z-0"
          />
          {/* Overlay for readability */}
          <div className="absolute inset-0 bg-white/20 z-0"></div>

          {/* Page content – sits on top of the background image */}
          <div className="relative z-10 py-8">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/registration-form" element={<RegistrationForm />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/who-we-serve" element={<WhoWeServe />} />
              <Route path="/faqs" element={<FAQs />} />
              <Route path="/terms-and-condition" element={<TermsAndCondition />} />
              <Route path="/what-we-offer" element={<TutorsAndSchools />} />
              <Route path="/subjects-and-disciplines" element={<SubjectsAndDiscipline />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            </Routes>
            <ScrollToTop /> 
          </div>
        </div>

        {/* Footer – no border, no background image */}
        <Footer />
      </div>
            <ToastContainer />
    </div>
  );
}

export default App;





